import styled from 'styled-components';
import { breakPoints, customBreakPoint, mobileBreakPoint } from '~/styles/break-points';

export const GalleryStyle = styled.div<{ $aspectRatio?: string; $objectPosition?: string }>`
	position: relative;
	min-width: 0;
	height: max-content;

	picture {
		display: contents;
	}

	img,
	video {
		// only used on summary page right now
		aspect-ratio: ${(props) => (props.$aspectRatio ? `${props.$aspectRatio} !important` : 'inherit')};
		object-position: ${(props) => (props.$objectPosition ? `${props.$objectPosition}` : 'inherit')};
	}

	.control-button {
		z-index: 8;
		background: #ffffff;

		&.close-fullscreen {
			position: absolute;
			top: 12px;
			right: 12px;
		}

		&:hover {
			background: #ffffff !important;
		}
	}

	.controls-left {
		position: absolute;
		bottom: 28px;
		left: 40px;
		display: flex;
		gap: 8px;
	}

	.controls-right {
		position: absolute;
		bottom: 28px;
		right: 40px;
		display: flex;
		gap: 8px;
	}

	.close-avp {
		position: absolute;
		top: 12px;
		right: 12px;
	}

	.swiper-reset {
		pointer-events: none;
		${breakPoints({
			'1024': `
				img {
					pointer-events: auto;
				}
			`,
		})}
	}
`;

export const GalleryItemDefaultStyle = styled.div<{ $aspectRatio?: string }>`
	display: flex;
	height: 100%;
	width: 100%;

	> div {
		width: 100%;
	}

	img,
	video {
		aspect-ratio: 4 / 3;
		object-fit: cover;

		${(props) =>
			`${customBreakPoint(
				mobileBreakPoint,
				`
				aspect-ratio: ${props.$aspectRatio} !important;
			`,
			)}`}
	}
`;

export const GalleryItem2Style = styled.div`
	display: flex;
	height: 100%;
	width: 100%;

	.left-side {
		display: flex;
		aspect-ratio: 4 / 3;

		img,
		video {
			flex: 1;
			aspect-ratio: 4 / 3;
			object-fit: cover;
		}
	}

	.right-side {
		display: flex;
		flex: 1;
		height: 100%;
		min-width: 0;

		img,
		video {
			flex: 1;
			object-fit: cover;
			aspect-ratio: 2 / 3;
		}
	}
`;

export const GalleryItem3Style = styled.div`
	display: flex;
	height: 100%;
	width: 100%;

	.left-side {
		display: flex;
		aspect-ratio: 4 / 3;

		img,
		video {
			flex: 1;
			aspect-ratio: 4 / 3;
			object-fit: cover;
		}
	}

	.right-side {
		display: flex;
		flex-direction: column;
		aspect-ratio: 2 / 3;

		img,
		video {
			flex: 1;
			object-fit: cover;
		}
	}
`;

export const SpacingContainerStyles = styled.div<{
	$placed: 'top' | 'bottom' | 'left' | 'right';
	$aspectRatio?: string;
	$flex?: string;
}>`
	position: relative;
	display: flex;
	flex-direction: column;
	box-sizing: border-box;
	border: 0;
	width: 100%;
	flex: ${(props) => props.$flex || 1};
	aspect-ratio: ${(props) => props.$aspectRatio || 1};
	height: max-content;

	${(props) => (props.$placed === 'top' ? 'border-top: 4px solid white' : '')}
	${(props) => (props.$placed === 'bottom' ? 'border-bottom: 4px solid white' : '')}
	${(props) => (props.$placed === 'right' ? 'border-right: 4px solid white' : '')}
	${(props) => (props.$placed === 'left' ? 'border-left: 4px solid white' : '')} // optional implementation for spacing
    /* &::before {
		content: '';
		position: absolute;
		top: ${(props) => (props.$placed === 'bottom' ? 'unset' : '0')};
		bottom: ${(props) => (props.$placed === 'top' ? 'unset' : '0')};
		left: ${(props) => (props.$placed === 'right' ? 'unset' : '0')};
		right: ${(props) => (props.$placed === 'left' ? 'unset' : '0')};
		width: ${(props) => (['top', 'bottom'].includes(props.$placed) ? 'unset' : '4px')};
		height: ${(props) => (['top', 'bottom'].includes(props.$placed) ? '4px' : 'unset')};
		background-color: white;
		box-shadow: ${(props) => `inset ${['left', 'top'].includes(props.$placed) ? '4px' : '-4px'} 0 0 0 white`};
		z-index: 1;
	} */
`;
